/**
 * Updates the page title from data-page-title attribute
 * Head content is now inlined in HTML files
 */
export async function initHead() {
  const htmlEl = document.documentElement;
  const pageTitle = htmlEl.getAttribute("data-page-title");
  
  if (!pageTitle) {
    console.warn("data-page-title attribute not found on <html> tag");
    return;
  }

  // Update the title
  let titleEl = document.head.querySelector("title");
  if (!titleEl) {
    titleEl = document.createElement("title");
    document.head.insertBefore(titleEl, document.head.firstChild);
  }
  titleEl.textContent = pageTitle;
}

export async function initPartials() {
  // Header, footer, and carousel are now inlined in HTML files
  // Just update the footer year dynamically
  const footer = document.querySelector("footer");
  
  if (footer) {
    const yearEl = footer.querySelector("[data-year]");
    if (yearEl) {
      yearEl.textContent = String(new Date().getFullYear());
    }
  }

  // Return resolved promise for compatibility
  return Promise.resolve();
}


